import { Item } from '@sitecore-jss/sitecore-jss-nextjs';

/**
 * Type guard to check if a field is a Droptree field.
 *
 * @param value - The field value to check.
 * @returns True if the field is a Droptree field, otherwise false.
 */
export const isDropTree = (value: any): value is Item => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'id' in value &&
    'fields' in value &&
    'url' in value
  );
};
